





























































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
} from "vant";
import api from "../../../components/http/api";
import { RegisterInfo } from "./UserApi";
import moment from "moment";

declare const $: any;

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
  },
})
export default class UserInfoMerchant extends Vue {
  private navbarClass: string = "navbar1";
  private active: number = 2;
  private activeColor: string = process.env.VUE_APP_COLOR as string;
  private rTime: number = 0;
  private registerInfo: RegisterInfo = {} as RegisterInfo;
  private cusLvImg: string = "";
  private showkjzfmodal: boolean = false;

  protected created() {
    this.getCustomerInfo();
    this.getCustomerLevel();
  }

  protected getCustomerLevel() {
    api.get("/weixinmp/xsyx/myuser/getCustomerLevel").then((res: any) => {
      if (res.data.level === "游客") {
        this.cusLvImg = require("@/assets/image/kh-vimg/yk.svg");
      } else if (res.data.level === "V") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v.svg");
      } else if (res.data.level === "V0") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v0.svg");
      } else if (res.data.level === "V0+") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v0plus.svg");
      } else if (res.data.level === "V1") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v1.svg");
      } else if (res.data.level === "V1+") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v1plus.svg");
      } else if (res.data.level === "V2") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v2.svg");
      } else if (res.data.level === "V2+") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v2plus.svg");
      } else if (res.data.level === "V3") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v3.svg");
      } else if (res.data.level === "V3+") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v3plus.svg");
      } else if (res.data.level === "V4") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v4.svg");
      } else if (res.data.level === "V4+") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v4plus.svg");
      } else if (res.data.level === "V5") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v5.svg");
      } else if (res.data.level === "V5+") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v5plus.svg");
      }
    });
  }

  protected getCustomerInfo() {
    api.get("/weixinmp/xsyx/myuser/getCustomerInfo").then((res: any) => {
      if (res.data.flag === "0") {
        if (res.data.idno.length == 15) {
          res.data.idno = res.data.idno.replace(
            /^(.{6})(?:\d+)(.{4})$/,
            "$1******$2"
          );
        } else {
          res.data.idno = res.data.idno.replace(
            /^(.{6})(?:\d+)(.{4})$/,
            "$1********$2"
          );
        }
        console.log(
          "%cUserInfo.vue line:175 idno",
          "color: #007acc;",
          res.data.idno
        );
        res.data.phone = res.data.phone.replace(
          /(\d{3})\d{4}(\d{4})/,
          "$1****$2"
        );
        console.log(
          "%cUserInfo.vue line:179 phone",
          "color: #007acc;",
          res.data.phone
        );
        this.registerInfo = res.data;
        // this.checkKjzfNotify();
      } else if (res.data.flag === "1") {
        this.registerInfo = res.data;
        const interval = window.setInterval(() => {
          if (--this.rTime <= 0) {
            window.clearInterval(interval);
            this.$router.replace("/main/user/register");
          }
        }, 2000);
      }
    });
  }

  protected clickAvatr() {
    if (this.registerInfo.flag === "0") {
      this.$router.push({ path: `/main/user/update/` + this.registerInfo.id });
    } else {
      this.$router.replace("/main/user/register");
    }
  }

  protected jumpToActivity() {
    this.$router.replace("/main/coupon/couponList");
  }

  protected jumpToCard() {
    this.$router.replace("/main/signup/signupList");
  }

  protected jumpToRecommend() {
    this.$router.replace("/main/recommend/beforeMerchantRecommendHome");
  }

  protected callPhone() {
    window.location.href = "tel://" + "19951792726";
  }

  private checkKjzfNotify() {
    const lastMonth = moment().subtract(31, "days").format("YYYYMM");
    const todayDay = moment().format("DD HH");
    if (todayDay < "10 09") {
      $(".mask-black,.modal").css("display", "none");
    } else {
      // api.get("/weixinmp/xsyx/myuser/checkKjzfNotify").then((res: any) => {
      //   if (res.data.flag) {
      //     $(".mask-black,.modal").css("display", "none");
      //   } else {
      //     $(".mask-black,.modal").css("display", "block");
      //   }
      // });
      $(".mask-black,.modal").css("display", "none");
    }
  }

  private closeKjzfmodal() {
    $(".mask-black,.modal").css("display", "none");
  }

  private tokjzfraffle() {
    this.$router.replace("/main/coupon/getCouponFromNotify/2&D");
  }

  private jumpToSydHome() {
    this.$router.replace("/main/syd/sydHome");
  }
  private jumpToXjqyHome() {
    this.$router.replace("/main/xjqy/xjqyHome");
  }
  private jumpToMerchantList() {
    this.$router.replace("/main/ydsq/merchantList");
  }
}
